import { BPMAlbum } from 'bpm-web-generic';
import * as toastr from 'toastr'
import { VOD } from "bpm-client-api/lib/endpoints/media";

export function shareAlbum(album: BPMAlbum) {
    let el = document.createElement('input')!
    el.setAttribute('style', 'position: absolute; top: -10000px; left: -1000px')
    document.body.appendChild(el)
    el.value = `https://${location.hostname}/share/${album.id}`
    el.select()
    el.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(el)
    toastr.success('Link Copied!')
}

export function shareVod(vod: VOD) {
    let el = document.createElement('input')!
    el.setAttribute('style', 'position: absolute; top: -10000px; left: -1000px')
    document.body.appendChild(el)
    el.value = `https://${location.hostname}/bpmtv#${vod.id}`
    el.select()
    el.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(el)
    toastr.success('Link Copied!')
}

export function shareLink(link: string) {
    let el = document.createElement('input')!
    el.setAttribute('style', 'position: absolute; top: -10000px; left: -1000px')
    document.body.appendChild(el)
    el.value = link
    el.select()
    el.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(el)
    toastr.success('Link Copied!')
}


// WEBPACK FOOTER //
// ./src/manager/ShareManager.ts